import { AiFormDraft } from './ai-form.types';

const PREFIX = 'ai-form-draft.';
const MAX_AGE = 7 * 24 * 60 * 60 * 1000;
export const AI_FORM_QUERY = 'aiFormDraft';

export class AiFormDrafts {
    constructor(private readonly storage: Storage, private readonly scope: () => string) {}

    get(id: string): AiFormDraft | null {
        if (!/^[a-zA-Z0-9-]{1,80}$/.test(id)) return null;
        const raw = this.storage.getItem(PREFIX + id);
        if (!raw) return null;
        let draft: AiFormDraft;
        try { draft = JSON.parse(raw); } catch { return null; }
        if (draft.id !== id || draft.scope !== this.scope() || !Number.isFinite(draft.createdAt)
            || draft.createdAt < Date.now() - MAX_AGE || typeof draft.route !== 'string'
            || !draft.route.startsWith('/core/')) return null;
        const url = new URL(draft.route, window.location.origin);
        if (url.origin !== window.location.origin || url.searchParams.get(AI_FORM_QUERY) !== id) return null;
        return draft;
    }

    save(draft: AiFormDraft): void {
        this.storage.setItem(PREFIX + draft.id, JSON.stringify(draft));
    }

    create(form: string, title: string, path: string, values: Record<string, unknown>, id = crypto.randomUUID()): AiFormDraft {
        this.prune();
        if (!/^[a-zA-Z0-9-]{1,80}$/.test(id)) throw new Error('Некорректный ID черновика');
        const url = new URL(path, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Форма должна находиться в приложении');
        url.searchParams.set(AI_FORM_QUERY, id);
        const draft: AiFormDraft = {
            id, scope: this.scope(), form, title, values,
            route: url.pathname + url.search + url.hash,
            createdAt: Date.now(), visitedAt: null,
        };
        this.save(draft);
        return draft;
    }

    private prune(): void {
        for (const key of Object.keys(this.storage)) {
            if (!key.startsWith(PREFIX)) continue;
            try {
                const draft = JSON.parse(this.storage.getItem(key)!);
                if (draft.createdAt < Date.now() - MAX_AGE || draft.scope !== this.scope()) this.storage.removeItem(key);
            } catch {
                this.storage.removeItem(key);
            }
        }
    }
}
